import React from 'react';
import { useSync } from '../hooks/useSync';
import './SyncIndicator.css';

export const SyncIndicator: React.FC = () => {
  const { syncStatus, lastSyncTime, isConnected } = useSync();

  const getStatusColor = () => {
    switch (syncStatus) {
      case 'connected':
        return 'green';
      case 'syncing':
        return 'yellow';
      case 'disconnected':
        return 'red';
      case 'error':
        return 'red';
      default:
        return 'gray';
    }
  };

  const getStatusText = () => {
    switch (syncStatus) {
      case 'connected':
        return 'All changes saved';
      case 'syncing':
        return 'Syncing...';
      case 'disconnected':
        return 'Offline - changes will sync when connected';
      case 'error':
        return 'Sync error - retrying...';
      default:
        return 'Unknown';
    }
  };

  const formatLastSync = () => {
    if (!lastSyncTime) return '';
    
    const now = new Date();
    const diff = now.getTime() - lastSyncTime.getTime();
    const seconds = Math.floor(diff / 1000);
    
    if (seconds < 60) return 'Just now';
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    return `${Math.floor(seconds / 86400)}d ago`;
  };

  return (
    <div className="sync-indicator">
      <div className={`sync-dot ${getStatusColor()}`} />
      <div className="sync-text">
        <span className="sync-status">{getStatusText()}</span>
        {isConnected && lastSyncTime && (
          <span className="sync-time">Last sync: {formatLastSync()}</span>
        )}
      </div>
    </div>
  );
};